import { isEmpty } from 'lodash';
import metaDatabasePaymentGatewayProfilesReducer from 'store/reducers/metaDatabase.paymentGatewayProfiles.reducer';
import metaDatabaseAuthUserReducer from './metaDatabase.authUser.reducer';
import metaDatabaseCompaniesReducer from './metaDatabase.companies.reducer';
import metaDatabaseCruiseLinesReducer from './metaDatabase.cruiseLines.reducer';
import metaDatabaseCruiseLineIncludesReducer from './metaDatabase.cruiseLineIncludes.reducer';
import metaDatabaseCruiseLinePhotosReducer from './metaDatabase.cruiseLinePhotos.reducer';
import metaDatabaseCruiseLinePortsReducer from './metaDatabase.cruiseLinePorts.reducer';
import metaDatabaseCruiseLineSailingsReducer from './metaDatabase.cruiseLineSailings.reducer';
import metaDatabaseCruiseLineShipsReducer from './metaDatabase.cruiseLineShips.reducer';
import metaDatabaseEmailTemplatesReducer from './metaDatabase.emailTemplate.reducer';
import metaDatabaseCurrenciesReducer from './metaDatabase.currencies.reducer';
import metaDatabaseDestinationsReducer from './metaDatabase.destinations.reducer';
import metaDatabaseHotelsReducer from './metaDatabase.hotels.reducer';
import metaDatabaseHotelRatePlansReducer from './metaDatabase.hotelRatePlans.reducer';
import metaDatabaseDestinationDocumentsPlansReducer from './metaDatabase.destinationDocuments.reducer';
import metaDatabaseInsurancesReducer from './metaDatabase.insurances.reducer';
import metaDatabaseMembersReducer from './metaDatabase.members.reducer';
import metaDatabaseMemberTripsReducer from './metaDatabase.memberTrips.reducer';
import metaDatabaseMemberEmailsReducer from './metaDatabase.memberEmails.reducer';
import metaDatabaseMemberAssistantsReducer from './metaDatabase.memberAssistants.reducer';
import metaDatabaseMemberPhonesReducer from './metaDatabase.memberPhones.reducer';
import metaDatabaseMemberReportsReducer from './metaDatabase.memberReports.reducer';
import metaDatabaseOauthClientsReducer from './metaDatabase.oauthClients.reducer';
import metaDatabaseOauthClientRedirectUrlsReducer from './metaDatabase.oauthClientRedirectUrls.reducer';
import metaDatabasePackageOffersReducer from './metaDatabase.packageOffers.reducer';
import metaDatabasePackageOfferServicesReducer from './metaDatabase.packageOfferServices.reducer';
import metaDatabasePaymentMethodsReducer from './metaDatabase.paymentMethods.reducer';
import metaDatabasePaymentProcessesReducer from './metaDatabase.paymentProcesses.reducer';
import metaDatabaseRefundsReducer from './metaDatabase.refunds.reducer';
import metaDatabaseRequestsReducer from './metaDatabase.requests.reducer';
import metaDatabaseRequestQuotesReducer from './metaDatabase.requestQuotes.reducer';
import metaDatabaseReservationCancellationApprovalsReducer from './metaDatabase.reservationCancellationApprovals.reducer';
import metaDatabaseReservationCancellationNumbersReducer from './metaDatabase.reservationCancellationNumbers.reducer';
import metaDatabaseReservationComponentHistoriesReducer from './metaDatabase.reservationComponentHistories.reducer';
import metaDatabaseReservationsReducer from './metaDatabase.reservations.reducer';
import metaDatabaseReservationHotelsReducer from './metaDatabase.reservationHotels.reducer';
import metaDatabaseReservationInformativeInvoicesReducer from './metaDatabase.reservationInformativeInvoices.reducer';
import metaDatabaseReservationServicesReducer from './metaDatabase.reservationServices.reducer';
import metaDatabaseReservationTransactionsReducer from './metaDatabase.reservationTransactions.reducer';
import metaDatabaseRolesReducer from './metaDatabase.roles.reducer';
import metaDatabaseTransactionTemplatesReducer from './metaDatabase.transactionTemplates.reducer';
import metaDatabaseTravelerPreferencesReducer from './metaDatabase.travelerPreferences.reducer';
import metaDatabaseTravelAgenciesReducer from './metaDatabase.travelAgencies.reducer';
import metaDatabaseUsersReducer from './metaDatabase.users.reducer';
import metaDatabaseUserTemplatesReducer from './metaDatabase.userTemplates.reducer';
import metaDatabaseVendorsReducer from './metaDatabase.vendors.reducer';
import metaDatabaseVendorServicesReducer from './metaDatabase.vendorServices.reducer';
import metaDatabaseReservationRelationsReducer from './metaDatabase.reservationRelations.reducer';
import metaDatabaseZinrelosReducer from './metaDatabase.zinrelos.reducer';

const initialState = {
    cruiseLines: {},
    cruiseLineIncludes: {},
    cruiseLinePhotos: {},
    cruiseLinePorts: {},
    cruiseLineSailings: {},
    cruiseLineShips: {},
    emailTemplates: {},
    companies: {},
    currencies: {},
    destinations: {},
    destinationDocuments: {},
    hotels: {},
    hotelRatePlans: {},
    insurances: {},
    memberEmails: {},
    memberPhones: {},
    members: {},
    memberTrips: {},
    oauthClients: {},
    oauthClientRedirectUrls: {},
    packageOffers: {},
    packageOfferServices: {},
    paymentGatewayProfiles: {},
    paymentMethods: {},
    paymentProcesses: {},
    reports: {},
    refunds: {},
    requests: {},
    requestQuotes: {},
    reservationCancellationApprovals: {},
    reservationCancellationNumbers: {},
    reservationComponentHistories: {},
    reservationRelations: {},
    reservations: {},
    reservationHotels: {},
    reservationInformativeInvoices: {},
    reservationServices: {},
    reservationTransactions: {},
    travelerPreferences: {},
    roles: {},
    transactionTemplates: {},
    travelAgencies: {},
    users: {},
    userTemplates: {},
    vendors: {},
    vendorServices: {},
    zinrelos: {},
};

export default function (st, action)
{
    const state = isEmpty(st) ? initialState : st;

    state.authUser = metaDatabaseAuthUserReducer(state.authUser, action);
    state.companies = metaDatabaseCompaniesReducer(state.companies, action);
    state.cruiseLines = metaDatabaseCruiseLinesReducer(state.cruiseLines, action);
    state.cruiseLineIncludes = metaDatabaseCruiseLineIncludesReducer(state.cruiseLineIncludes, action);
    state.cruiseLinePhotos = metaDatabaseCruiseLinePhotosReducer(state.cruiseLinePhotos, action);
    state.cruiseLinePorts = metaDatabaseCruiseLinePortsReducer(state.cruiseLinePorts, action);
    state.cruiseLineSailings = metaDatabaseCruiseLineSailingsReducer(state.cruiseLineSailings, action);
    state.cruiseLineShips = metaDatabaseCruiseLineShipsReducer(state.cruiseLineShips, action);
    state.emailTemplates = metaDatabaseEmailTemplatesReducer(state.emailTemplates, action);
    state.currencies = metaDatabaseCurrenciesReducer(state.currencies, action);
    state.destinations = metaDatabaseDestinationsReducer(state.destinations, action);
    state.destinationDocuments = metaDatabaseDestinationDocumentsPlansReducer(state.destinationDocuments, action);
    state.hotels = metaDatabaseHotelsReducer(state.hotels, action);
    state.hotelRatePlans = metaDatabaseHotelRatePlansReducer(state.hotelRatePlans, action);
    state.insurances = metaDatabaseInsurancesReducer(state.insurances, action);
    state.memberEmails = metaDatabaseMemberEmailsReducer(state.memberEmails, action);
    state.memberAssistants = metaDatabaseMemberAssistantsReducer(state.memberAssistants, action);
    state.memberPhones = metaDatabaseMemberPhonesReducer(state.memberPhones, action);
    state.memberReports = metaDatabaseMemberReportsReducer(state.memberReports, action);
    state.memberTrips = metaDatabaseMemberTripsReducer(state.memberTrips, action);
    state.members = metaDatabaseMembersReducer(state.members, action);
    state.oauthClients = metaDatabaseOauthClientsReducer(state.oauthClients, action);
    state.oauthClientRedirectUrls = metaDatabaseOauthClientRedirectUrlsReducer(state.oauthClientRedirectUrls, action);
    state.packageOffers = metaDatabasePackageOffersReducer(state.packageOffers, action);
    state.packageOfferServices = metaDatabasePackageOfferServicesReducer(state.packageOfferServices, action);
    state.paymentGatewayProfiles = metaDatabasePaymentGatewayProfilesReducer(state.paymentGatewayProfiles, action);
    state.paymentMethods = metaDatabasePaymentMethodsReducer(state.paymentMethods, action);
    state.paymentProcesses = metaDatabasePaymentProcessesReducer(state.paymentProcesses, action);
    state.refunds = metaDatabaseRefundsReducer(state.refunds, action);
    state.requests = metaDatabaseRequestsReducer(state.requests, action);
    state.requestQuotes = metaDatabaseRequestQuotesReducer(state.requestQuotes, action);
    state.reservationCancellationApprovals = metaDatabaseReservationCancellationApprovalsReducer(state.reservationCancellationApprovals, action);
    state.reservationCancellationNumbers = metaDatabaseReservationCancellationNumbersReducer(state.reservationCancellationNumbers, action);
    state.reservationComponentHistories = metaDatabaseReservationComponentHistoriesReducer(state.reservationComponentHistories, action);
    state.reservations = metaDatabaseReservationsReducer(state.reservations, action);
    state.reservationHotels = metaDatabaseReservationHotelsReducer(state.reservationHotels, action);
    state.reservationInformativeInvoices = metaDatabaseReservationInformativeInvoicesReducer(state.reservationInformativeInvoices, action);
    state.reservationRelations = metaDatabaseReservationRelationsReducer(state.reservationRelations, action);
    state.reservationServices = metaDatabaseReservationServicesReducer(state.reservationServices, action);
    state.reservationTransactions = metaDatabaseReservationTransactionsReducer(state.reservationTransactions, action);
    state.roles = metaDatabaseRolesReducer(state.roles, action);
    state.travelAgencies = metaDatabaseTravelAgenciesReducer(state.travelAgencies, action);
    state.travelerPreferences = metaDatabaseTravelerPreferencesReducer(state.travelerPreferences, action);
    state.transactionTemplates = metaDatabaseTransactionTemplatesReducer(state.transactionTemplates, action);
    state.users = metaDatabaseUsersReducer(state.users, action);
    state.userTemplates = metaDatabaseUserTemplatesReducer(state.userTemplates, action);
    state.vendors = metaDatabaseVendorsReducer(state.vendors, action);
    state.vendorServices = metaDatabaseVendorServicesReducer(state.vendorServices, action);
    state.zinrelos = metaDatabaseZinrelosReducer(state.zinrelos, action);

    return state;
}
